import React from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from 'react-router-dom'

import Login from './login';
import Logout from './Logout';
import NotFound from './NotFound';
import ApproveComponent from './ApproveComponent';
import DenyComponent from './DenyComponent';
import PrivateRoute from './PrivateRoute'
import StartComponent from './start'

import config from 'config';
const { auth } = config;


class MainComponent extends React.Component {

    render() {
        const { authHandler, userInfoHandler, bannerHandler, isAuthenticated, token, user } = this.props;

        return (
            <div style={{ flex: '1 1 auto', width: '100%', minWidth: 0, minHeight: 0 }}>
                <BrowserRouter>
                    <Routes>  
                        <Route path="/login" 
                            element={<Login authHandler={authHandler} loginUrl={auth.loginUrl} isAuthenticated={isAuthenticated} token={token}/>}
                        />      
                        <Route path='/logout'
                            element={<Logout authHandler={authHandler} logoutUrl={auth.logoutUrl} />}
                        />
                        <Route path='/approve' element={<ApproveComponent />} />
                        <Route path='/deny' element={<DenyComponent />} />
                        <Route path='/home' element={
                            <PrivateRoute isAuthenticated={isAuthenticated}>
                                <StartComponent user={user} bannerHandler={bannerHandler} userInfoHandler={userInfoHandler} />
                            </PrivateRoute>
                        } />
                        <Route path="/" element={<Navigate to="/home" replace />} />
                        <Route path="*" element={<Navigate to="/home" replace />} />      
                    </Routes>
                </BrowserRouter>
            </div>
        );
    }
}


export default MainComponent;
